import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { appReducer, RootState } from './AppReducer';
import { useDispatch, useSelector } from 'react-redux';
import { AppEpics } from './AppEpics';
import { ApolloEpics } from './ApolloEpics';
import { AuthEpics } from './AuthEpics';
import { FilterEpics } from './FilterEpics';
import { UserEpics } from './UserEpics';
import { ScreenEpics } from './ScreenEpics';
import { ToastEpics } from './toast/ToastEpics';
import { SearchEpics } from './search/SearchEpics';
import { EngagementDashboardEpics } from './engagementDashboard/EngagementDashboardEpics';

const epics = combineEpics(
	...AuthEpics.init(),
	...AppEpics.init(),
	...ApolloEpics.init(),
	...FilterEpics.init(),
	...UserEpics.init(),
	...ScreenEpics.init(),
	...ToastEpics.init(),
	...SearchEpics.init(),
	...EngagementDashboardEpics.init()
);

const epicMiddleware = createEpicMiddleware<any, any, any>();

export const runEpics = () => {
	epicMiddleware.run(epics);
};
export const store = configureStore({
	reducer: combineReducers({
		appState: appReducer
	}),
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({ thunk: false, serializableCheck: false, immutableCheck: false }).concat(
			epicMiddleware
		)
});
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
